import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'superflex-editar-btn',
    template: `
        <p-button
            label="{{ 'BOTONES.editar' | translate }}"
            [icon]="icon"
            [styleClass]="styleClass"
            (onClick)="onClick.emit()"
            [disabled]="isDisabled">
        </p-button>`,
})
export class EditBtnComponent {

    @Input() isDisabled: boolean;
    @Output() onClick = new EventEmitter<any>();
    @Input() icon = '';
    @Input() styleClass = 'p-mr-2';

    constructor() {/***/}
}
